<template>
  <HrPageLayout
    title="Documents From Attorney"
    subtitle="Shared legal documents and acknowledgements"
    :breadcrumb-items="[{ label: 'Home', route: '/dashboard' }, { label: 'Documents From Attorney' }]"
  >
    <div class="hr-chart-card">
      <div class="hr-chart-body">
        <div class="hr-table-wrapper">
          <table class="hr-table">
            <thead>
              <tr>
                <th>Type</th>
                <th>Title</th>
                <th>Status</th>
                <th>Shared At</th>
                <th>Acknowledged</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="d in docs" :key="d.id">
                <td>{{ d.doc_type }}</td>
                <td>{{ d.title }}</td>
                <td>{{ normalizeStatus(d.status) }}</td>
                <td>{{ d.shared_at || '—' }}</td>
                <td>{{ d.acknowledged_at || 'Pending' }}</td>
                <td>
                  <button class="hr-btn hr-btn-sm hr-btn-outline-primary" :disabled="!d.file_path" @click="openAttachment(d)">
                    View Attachment
                  </button>
                  <button class="hr-btn hr-btn-sm hr-btn-success" :disabled="!!d.acknowledged_at" @click="ack(d)">
                    {{ d.acknowledged_at ? 'Acknowledged' : 'Acknowledge' }}
                  </button>
                </td>
              </tr>
              <tr v-if="!docs.length"><td colspan="6" class="hr-text-center">No shared documents</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </HrPageLayout>
</template>

<script>
/* eslint-disable */
import HrPageLayout from "@/components/hrActions/HrPageLayout.vue";
import { execute, executeDownload, authUrl, toast } from "@/api";

export default {
  name: "DocumentsFromAttorney",
  components: { HrPageLayout },
  data() {
    return { docs: [] };
  },
  mounted() {
    this.loadDocs();
  },
  methods: {
    normalizeStatus(v) {
      const s = String(v || "").trim().toLowerCase();
      if (!s) return "active";
      return s === "share" ? "shared" : s;
    },
    async loadDocs() {
      const fd = new FormData();
      fd.append("function", "getAttorneySharedDocumentsForMe");
      const res = await execute(fd, authUrl);
      this.docs = res?.data?.data?.documents || [];
    },
    async ack(d) {
      const fd = new FormData();
      fd.append("function", "acknowledgeAttorneyDocument");
      fd.append("documentId", String(d.id));
      const res = await execute(fd, authUrl);
      if (res?.data?.success) {
        toast.success("Acknowledged");
        await this.loadDocs();
      } else {
        toast.error(res?.data?.message || "Acknowledge failed");
      }
    },
    async openAttachment(d) {
      if (!d?.id || !d?.file_path) return;
      try {
        const fd = new FormData();
        fd.append("function", "downloadCountyAttorneyDocument");
        fd.append("id", String(d.id));
        const res = await executeDownload(fd, authUrl);
        const blob = res?.data;
        if (!(blob instanceof Blob)) return toast.error("Could not open attachment");
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      } catch (_) {
        toast.error("Could not open attachment");
      }
    }
  }
};
</script>
